import { LinkPlainInternal } from 'src/elements/links/Link.plain';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

export const PeopleMagicProfitAnnouncementBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 2.5rem;

  @media (max-width: ${layout.md}) {
    .coming-soon-heading,
    .people-magic-profit-announcement-paragraph {
      display: none;
    }
  }
`;

export const LearnMoreLink = styled(LinkPlainInternal)`
  text-decoration: underline;
  font-size: 1.25rem;
  color: ${palette.white};
  transition: opacity 300ms ease-in-out;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: ${layout.md}) {
    display: none;
  }
`;

export const JoinMasterclassLink = styled(LinkPlainInternal)`
  font-family: 'Walsheim';
  font-weight: 700;
  line-height: 113%;
  font-size: 1.25rem;
  color: ${palette.white};
  transition: opacity 300ms ease-in-out;
  display: none;
  justify-content: center;
  align-items: center;
  column-gap: 0.7rem;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: ${layout.md}) {
    display: flex;
  }
`;

export const TopInfoBarCustomStyles = css`
  @media screen and (max-width: ${layout.sm}) {
    padding: 0.625rem;

    > span {
      top: 3px;
    }
  }
`;
